import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import Axios from "axios";
import CustomInput from "../components/CustomInput";
import CustomSelect from "../components/CustomSelect";
import NoResultCas from "../helpers/NoResultCas";
import { Token } from "../tmp/Token";
import ContentLoader from "react-content-loader";
import img from "../images/sprite_3.png";
import ContactDAO from "../DAO/ContactDAO";
import CommonDAO from "../DAO/CommonDAO";
import AccountDAO from "../DAO/AccountDAO";
// import Select from 'react-select';
import SearchSelect from "../helpers/SearchSelect";
import CommonFunctions from "../helpers/CommonFunctions";
import { RoutesPath } from "../values/RoutesPath";
import DataLoadingError from "../components/DataLoadingError";
import { notify } from "../helpers/FlashMessage";
import { acl } from "../services/acl";
import TopOptions from "./TopOptions";
import { MessagesText } from "../values/MessagesText";
import configuration from "../config/configuration";

class ContactsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            data: null,
            totalItems: 0,
            account_type: "",
            account_id: "",
            first_name: "",
            last_name: "",
            phone: "",
            category: "",
            accounts: [],

            account_id_operator: "is",
            first_name_operator: "like",
            last_name_operator: "like",
            phone_operator: "like",
            category_operator: "is",

            search: false,
            advancedSearch: false,

            is_loaded: false,
            selectedOption: {},
            error: {
                is: false,
                message: "",
            },

            orderBy: 0,
            key: "",
            disabledData: 0,
        };
    }

    async componentDidMount() {
        this.preload();
        this.setState({ is_loaded: false }, () => this.getAll());
        this.getAccounts();
    }

    async getAll() {
        try {
            const { disabledData } = this.state;
            this.setLoadingError({ is: false, message: "" });
            const { orderBy, key, advancedSearch, search, pageNumber, first_name, last_name, phone, category, account_id, account_id_operator, first_name_operator, last_name_operator, phone_operator, category_operator } = this.state;
            let data = ContactDAO.getSearchData({ advancedSearch, search, first_name, last_name, phone, category, account_id, account_id_operator, first_name_operator, last_name_operator, phone_operator, category_operator });
            data["disabled"] = {
                value: disabledData,
                op: "is",
            };
            if (orderBy !== 0 && key.length !== 0) {
                data["orderby"] = {
                    col: key,
                    dir: orderBy === 1 ? "ASC" : "DESC",
                };
            } else {
                data["orderby"] = {
                    col: "id",
                    dir: "DESC",
                };
            }
            const response = await ContactDAO.getALLContacts(pageNumber, {}, data);
            this.setState({ is_loaded: true, data: response.data, totalItems: response.data.total });
        } catch (error) {
            this.setState({ is_loaded: true });
            this.setLoadingError({ is: true, message: error.message });
        }
    }

    setLoadingError(error) {
        this.setState((prevState) => ({
            ...prevState,
            error: {
                ...prevState.error,
                is: error.is,
                message: error.message,
            },
        }));
    }
    // for full account select bocx in search

    getAccounts = async (inputValue = null, callback = () => { }) => {
        try {
            let data = {};
            if (inputValue) {
                data.libelle = {
                    value: inputValue,
                    op: "smart",
                };
            }
            const response = await AccountDAO.getALLAccounts(1, {}, data);
            this.setState({ accounts: response.data.comptes });
            const convertedArray = CommonFunctions.convertDataForSelectBox(response.data.comptes, "id", "libelle");
            callback(convertedArray);
        } catch (error) {
            this.setState({ is_loaded: false });
            notify({ msg: error.message, type: "danger" });
        }
    };

    sort(property) {
        const sortedData = CommonDAO.sortData(this.state.data.contacts, property);
        const data = this.state.data;
        data.contacts = [...sortedData];
        this.setState({ data });
    }

    reverse(property) {
        const sortedData = CommonDAO.reverseData(this.state.data.contacts, property);
        const data = this.state.data;
        data.contacts = [...sortedData];
        this.setState({ data });
    }

    handleKeyDown(e) {
        if (e.key === "Enter") {
            this.setState({ pageNumber: 1, is_loaded: false }, () => this.getAll());
        }
    }
    resetSearch() {
        this.setState(
            {
                is_loaded: false,
                account_id: "",
                first_name: "",
                last_name: "",
                phone: "",
                category: "",

                account_id_operator: "is",
                first_name_operator: "like",
                last_name_operator: "like",
                phone_operator: "like",
                category_operator: "is",

                selectedOption: {},
            },
            () => this.getAll()
        );
    }
    getOrderBy() {
        const { orderBy } = this.state;
        switch (orderBy) {
            case 0:
                return 1;
                break;
            case 1:
                return -1;
                break;
            case -1:
                return 1;
                break;
            default:
                return 0;
                break;
        }
    }
    async delete(id) {
        try {
            var delete_item = window.confirm("Etes-vous sûr de vouloir faire effectuer cette action, les modifications seront définitives !");
            if (delete_item) {
                const data = {
                    disabled: 1,
                };
                const response = await ContactDAO.deleteContact(id, {}, data);

                if (response.data && response.data.status === "ok") {
                    notify({ msg: MessagesText.contact.delete, type: "success" });
                    this.getAll();
                } else {
                    notify({ msg: response.data.msg, type: "danger" });
                }
            }
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }
    async restore(id) {
        try {
            var delete_item = window.confirm("Etes-vous sûr de vouloir faire effectuer cette action, les modifications seront définitives !");
            if (delete_item) {
                const data = {
                    disabled: 0,
                };
                const response = await ContactDAO.deleteContact(id, {}, data);

                if (response.data && response.data.status === "ok") {
                    notify({ msg: MessagesText.contact.restore, type: "success" });
                    this.getAll();
                } else {
                    notify({ msg: response.data.msg, type: "danger" });
                }
            }
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }
    componentWillUnmount() {
        this.storeSearchInCookies();
        window.removeEventListener('beforeunload', this.storeSearchInCookies);
    }

    preload = () => {
        this.getSearchFromCookies();
        window.addEventListener('beforeunload', this.storeSearchInCookies);
    }
    render() {
        const {
            disabledData,
            key,
            orderBy,
            error,
            is_loaded,
            data,
            pageNumber,
            totalItems,
            search,
            account_type,
            first_name,
            last_name,
            phone,
            account_id,
            category,
            accounts,
            advancedSearch,
            account_id_operator,
            first_name_operator,
            last_name_operator,
            phone_operator,
            category_operator,
        } = this.state;
        return (
            <div>
                <TopOptions title="Contacts">
                    <button
                        className="btn_white"
                        data-shortcut_alias="create"
                        onClick={() => {
                            this.setState({ disabledData: disabledData === 1 ? 0 : 1 }, () => this.getAll());
                        }}
                    >
                        {disabledData === 0 ? " Archives" : "Actuel"}
                    </button>
                    {disabledData === 0 && acl.contact.add() && (
                        <button className="btn_bleu" data-shortcut_alias="create" onClick={() => this.props.history.push(RoutesPath.contact.add)}>
                            Créer
                        </button>
                    )}
                </TopOptions>
                <Bloc className="Bloc">
                    <div className="bloc_header">
                        <h2>{disabledData === 0 ? "Liste des contacts" : "Liste des contacts archivés"}</h2>
                        <div className="bloc_header_btns">
                            <a onClick={() => this.setState({ advancedSearch: false, search: search ? false : true })} className="sprite-bloc-search" />
                            <a onClick={() => this.resetSearch()} className="sprite-bloc-reload"></a>
                            <a onClick={() => this.setState({ search: false, advancedSearch: advancedSearch ? false : true })} href="#" className="sprite-bloc-star"></a>
                        </div>
                    </div>
                    <div className="bloc_content table_wrraper">
                        <table className="table processableTable" id="26555_e2d99ecca39dab4b0c717798144e1d8f" data-ajax_url="/invoices" data-object_table="invoices">
                            <thead>
                                {advancedSearch && (
                                    <tr className="table_th_orderable">
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomSelect
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    error={false}
                                                    onChange={(value) => {
                                                        this.setState({ account_id_operator: value.target.value });
                                                    }}
                                                    selectedValue={account_id_operator}
                                                    label="Compte"
                                                >
                                                    <option value="is" defaultValue>
                                                        est
                                                    </option>
                                                    <option value="is_not">n'est pas</option>
                                                </CustomSelect>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomSelect
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    error={false}
                                                    onChange={(value) => {
                                                        this.setState({ first_name_operator: value.target.value });
                                                    }}
                                                    selectedValue={first_name_operator}
                                                    label="Prénom"
                                                >
                                                    <option value="like" defaultValue>
                                                        contient
                                                    </option>
                                                    <option value="not_like">ne contient pas</option>
                                                    <option value="starts_with">commence par</option>
                                                    <option value="end_by">se termine par</option>
                                                    <option value="is">est</option>
                                                    <option value="is_not">n'est pas</option>
                                                    <option value="null">est vide</option>
                                                    <option value="not_null">n'est pas vide</option>
                                                </CustomSelect>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomSelect
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    error={false}
                                                    onChange={(value) => {
                                                        this.setState({ last_name_operator: value.target.value });
                                                    }}
                                                    selectedValue={last_name_operator}
                                                    label="Nom"
                                                >
                                                    <option value="like" defaultValue>
                                                        contient
                                                    </option>
                                                    <option value="not_like">ne contient pas</option>
                                                    <option value="starts_with">commence par</option>
                                                    <option value="end_by">se termine par</option>
                                                    <option value="is">est</option>
                                                    <option value="is_not">n'est pas</option>
                                                    <option value="null">est vide</option>
                                                    <option value="not_null">n'est pas vide</option>
                                                </CustomSelect>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomSelect
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    error={false}
                                                    onChange={(value) => {
                                                        this.setState({ phone_operator: value.target.value });
                                                    }}
                                                    selectedValue={phone_operator}
                                                    label="Portable"
                                                >
                                                    <option value="like" defaultValue>
                                                        contient
                                                    </option>
                                                    <option value="not_like">ne contient pas</option>
                                                    <option value="starts_with">commence par</option>
                                                    <option value="end_by">se termine par</option>
                                                    <option value="is">est</option>
                                                    <option value="is_not">n'est pas</option>
                                                    <option value="null">est vide</option>
                                                    <option value="not_null">n'est pas vide</option>
                                                </CustomSelect>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomSelect
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    error={false}
                                                    onChange={(value) => {
                                                        this.setState({ category_operator: value.target.value });
                                                    }}
                                                    selectedValue={category_operator}
                                                    label="Catégorie"
                                                >
                                                    <option value="is" defaultValue>
                                                        est
                                                    </option>
                                                    <option value="is_not">n'est pas</option>
                                                </CustomSelect>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_btn onClick={() => this.setState({ pageNumber: 1, is_loaded: false }, () => this.getAll())}>
                                                <Search_btn_icon aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                    <path
                                                        fill="#fff"
                                                        d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                    ></path>
                                                </Search_btn_icon>
                                            </Search_btn>
                                        </Th>
                                    </tr>
                                )}
                                {advancedSearch && (
                                    <tr className="table_th_orderable">
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomSelect
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    error={false}
                                                    onChange={(value) => {
                                                        this.setState({ account_id: value.target.value });
                                                    }}
                                                    selectedValue={account_id}
                                                    label="Compte"
                                                >
                                                    <option value="" defaultValue></option>
                                                    {accounts.map((account) => {
                                                        return <option value={account.id}>{account.libelle}</option>;
                                                    })}
                                                </CustomSelect>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomInput
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    onChange={(value) => {
                                                        this.setState({ first_name: value.target.value });
                                                    }}
                                                    value={first_name}
                                                    defaultValue={first_name}
                                                    label="Prénom"
                                                ></CustomInput>
                                                <Search_icon>
                                                    <Svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                        <path
                                                            fill="currentColor"
                                                            d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                        ></path>
                                                    </Svg>
                                                </Search_icon>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomInput
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    onChange={(value) => {
                                                        this.setState({ last_name: value.target.value });
                                                    }}
                                                    value={last_name}
                                                    defaultValue={last_name}
                                                    label="Nom"
                                                ></CustomInput>
                                                <Search_icon>
                                                    <Svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                        <path
                                                            fill="currentColor"
                                                            d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                        ></path>
                                                    </Svg>
                                                </Search_icon>
                                            </Search_input_container>
                                        </Th>

                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomInput
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    onChange={(value) => {
                                                        this.setState({ phone: value.target.value });
                                                    }}
                                                    label="Portable"
                                                    value={phone}
                                                    defaultValue={phone}
                                                ></CustomInput>
                                                <Search_icon>
                                                    <Svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                        <path
                                                            fill="currentColor"
                                                            d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                        ></path>
                                                    </Svg>
                                                </Search_icon>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomSelect
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    error={false}
                                                    onChange={(value) => {
                                                        this.setState({ category: value.target.value });
                                                    }}
                                                    selectedValue={category}
                                                    label="Catégorie"
                                                >
                                                    <option value="" defaultValue></option>
                                                    <option value="A">A</option>
                                                    <option value="B">B</option>
                                                    <option value="C">C</option>
                                                    <option value="D">D</option>
                                                    <option value="E">E</option>
                                                    <option value="F">F</option>
                                                </CustomSelect>
                                            </Search_input_container>
                                        </Th>
                                        <Th></Th>
                                    </tr>
                                )}
                                {search && (
                                    <tr className="table_th_orderable">
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                {/* <CustomSelect onKeyDown={this.handleKeyDown.bind(this)} error={false} onChange={(value) => { this.setState({ account_id: value.target.value }) }} selectedValue={account_id} label="Compte">
                                                    <option value="" defaultValue ></option>
                                                    {
                                                        accounts.map((account) => {
                                                            return (
                                                                <option value={account.id}>{account.libelle}</option>
                                                            );
                                                        })
                                                    } 
                                                </CustomSelect> */}

                                                <SearchSelect
                                                    fetchedUrl="/api/comptes"
                                                    HTTPMethod="post"
                                                    receivedObject="comptes"
                                                    optionLabelProperty="libelle"
                                                    optionValueProperty="id"
                                                    value={this.state.selectedOption}
                                                    placeholder="Compte"
                                                    onChange={(e) => {
                                                        this.setState({
                                                            selectedOption: e,
                                                            account_id: e && e.value,
                                                        });
                                                    }}
                                                />
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomInput
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    onChange={(value) => {
                                                        this.setState({ first_name: value.target.value });
                                                    }}
                                                    label="Prénom"
                                                    value={first_name}
                                                    defaultValue={first_name}
                                                ></CustomInput>
                                                <Search_icon>
                                                    <Svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                        <path
                                                            fill="currentColor"
                                                            d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                        ></path>
                                                    </Svg>
                                                </Search_icon>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomInput
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    onChange={(value) => {
                                                        this.setState({ last_name: value.target.value });
                                                    }}
                                                    label="Nom"
                                                    value={last_name}
                                                    defaultValue={last_name}
                                                ></CustomInput>
                                                <Search_icon>
                                                    <Svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                        <path
                                                            fill="currentColor"
                                                            d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                        ></path>
                                                    </Svg>
                                                </Search_icon>
                                            </Search_input_container>
                                        </Th>

                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomInput
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    onChange={(value) => {
                                                        this.setState({ phone: value.target.value });
                                                    }}
                                                    value={phone}
                                                    defaultValue={phone}
                                                    label="Portable"
                                                ></CustomInput>
                                                <Search_icon>
                                                    <Svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                        <path
                                                            fill="currentColor"
                                                            d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                        ></path>
                                                    </Svg>
                                                </Search_icon>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_input_container>
                                                <CustomSelect
                                                    onKeyDown={this.handleKeyDown.bind(this)}
                                                    error={false}
                                                    onChange={(value) => {
                                                        this.setState({ category: value.target.value });
                                                    }}
                                                    selectedValue={category}
                                                    label="Catégorie"
                                                >
                                                    <option value="" defaultValue></option>
                                                    <option value="A">A</option>
                                                    <option value="B">B</option>
                                                    <option value="C">C</option>
                                                    <option value="D">D</option>
                                                    <option value="E">E</option>
                                                    <option value="F">F</option>
                                                </CustomSelect>
                                            </Search_input_container>
                                        </Th>
                                        <Th backgroundColor="#fff">
                                            <Search_btn onClick={() => this.setState({ pageNumber: 1, is_loaded: false }, () => this.getAll())}>
                                                <Search_btn_icon aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                    <path
                                                        fill="#fff"
                                                        d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                    ></path>
                                                </Search_btn_icon>
                                            </Search_btn>
                                        </Th>
                                    </tr>
                                )}
                                <tr className="table_th_orderable">
                                    <Th key="compte" orderBy={key === "compte" && orderBy} onClick={() => this.setState({ key: "compte", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                        {((key === "compte" && orderBy === -1) || orderBy === 0 || key !== "compte") && <OrderUp />}
                                        {((key === "compte" && orderBy === 1) || orderBy === 0 || key !== "compte") && <OrderDown />}
                                        Compte
                                    </Th>
                                    <Th key="prenom" orderBy={key === "prenom" && orderBy} onClick={() => this.setState({ key: "prenom", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                        {((key === "prenom" && orderBy === -1) || orderBy === 0 || key !== "prenom") && <OrderUp />}
                                        {((key === "prenom" && orderBy === 1) || orderBy === 0 || key !== "prenom") && <OrderDown />}
                                        Prénom
                                    </Th>
                                    <Th key="nom" orderBy={key === "nom" && orderBy} onClick={() => this.setState({ key: "nom", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                        {((key === "nom" && orderBy === -1) || orderBy === 0 || key !== "nom") && <OrderUp />}
                                        {((key === "nom" && orderBy === 1) || orderBy === 0 || key !== "nom") && <OrderDown />}
                                        Nom
                                    </Th>
                                    <Th key="portable" orderBy={key === "portable" && orderBy} onClick={() => this.setState({ key: "portable", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                        {((key === "portable" && orderBy === -1) || orderBy === 0 || key !== "portable") && <OrderUp />}
                                        {((key === "portable" && orderBy === 1) || orderBy === 0 || key !== "portable") && <OrderDown />}
                                        Portable
                                    </Th>
                                    <Th key="categorie" orderBy={key === "categorie" && orderBy} onClick={() => this.setState({ key: "categorie", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                        {((key === "categorie" && orderBy === -1) || orderBy === 0 || key !== "categorie") && <OrderUp />}
                                        {((key === "categorie" && orderBy === 1) || orderBy === 0 || key !== "categorie") && <OrderDown />}
                                        Catégorie
                                    </Th>

                                    <Th className="table_actions" />
                                </tr>
                            </thead>
                            {!is_loaded && (
                                <tbody>
                                    {[1, 2, 3].map((index) => {
                                        return (
                                            <Tr key={"key__" + index}>
                                                <Td>
                                                    <ContentLoader width="160" height="20">
                                                        <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                    </ContentLoader>
                                                </Td>
                                                <Td>
                                                    <ContentLoader width="160" height="20">
                                                        <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                    </ContentLoader>
                                                </Td>
                                                <Td>
                                                    <ContentLoader width="160" height="20">
                                                        <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                    </ContentLoader>
                                                </Td>
                                                <Td>
                                                    <ContentLoader width="160" height="20">
                                                        <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                    </ContentLoader>
                                                </Td>
                                                <Td>
                                                    <ContentLoader width="160" height="20">
                                                        <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                    </ContentLoader>
                                                </Td>
                                                <Td>
                                                    <ContentLoader width="160" height="20">
                                                        <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                    </ContentLoader>
                                                </Td>
                                                <Td className="table_action">
                                                    <a className="sprite-table-edit-btn  tooltip" title="Modifier" data-confirm_msg data-removeable_element="parents::tr" target="_blank" />
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                                </tbody>
                            )}

                            {is_loaded && data && data.contacts.length != 0 && (
                                <tbody>
                                    {data &&
                                        data.contacts.map((contact, index) => {
                                            return (
                                                <Tr key={index}>
                                                    <Td
                                                        onClick={() => {
                                                            acl.contact.details() && this.props.history.push(`${RoutesPath.contact.details}/${contact.id}`);
                                                        }}
                                                    >
                                                        {contact.compte}
                                                    </Td>
                                                    <Td
                                                        onClick={() => {
                                                            acl.contact.details() && this.props.history.push(`${RoutesPath.contact.details}/${contact.id}`);
                                                        }}
                                                    >
                                                        {contact.prenom}
                                                    </Td>
                                                    <Td
                                                        onClick={() => {
                                                            acl.contact.details() && this.props.history.push(`${RoutesPath.contact.details}/${contact.id}`);
                                                        }}
                                                    >
                                                        {contact.nom}
                                                    </Td>
                                                    <Td
                                                        onClick={() => {
                                                            acl.contact.details() && this.props.history.push(`${RoutesPath.contact.details}/${contact.id}`);
                                                        }}
                                                    >
                                                        {contact.portable}
                                                    </Td>
                                                    <Td
                                                        onClick={() => {
                                                            acl.contact.details() && this.props.history.push(`${RoutesPath.contact.details}/${contact.id}`);
                                                        }}
                                                    >
                                                        {contact.categorie}
                                                    </Td>
                                                    <Td className="table_action">
                                                        {disabledData === 0 && acl.contact.update() && (
                                                            <a
                                                                onClick={() => {
                                                                    this.props.history.push(`${RoutesPath.contact.update}/${contact.id}`);
                                                                }}
                                                                className="sprite-table-edit-btn  tooltip"
                                                                title="Modifier"
                                                                data-confirm_msg
                                                                data-removeable_element="parents::tr"
                                                                target="_blank"
                                                            />
                                                        )}
                                                        {disabledData === 0 && acl.contact.disable() && <a onClick={() => this.delete(contact.id)} className="sprite-table-delete-btn  tooltip" title="Archiver" data-confirm_msg data-removeable_element="parents::tr" target="_blank" />}
                                                        {disabledData === 1 && acl.contact.restore() && <a onClick={() => this.restore(contact.id)} className="sprite-table-recover-btn restore_delivery_note tooltip" title="Restaurer" data-confirm_msg="" data-removeable_element="parents::tr"></a>}
                                                    </Td>
                                                </Tr>
                                            );
                                        })}

                                    <Tr>
                                        <Td colSpan={8} className="table_pagination">
                                            <div style={{ display: "inline-block", marginRight: "20px" }}>{/* <a href="#" onClick={() => { }} className="btn_white">Imprimer</a> */}</div>
                                            <div style={{ display: "inline-block" }}>
                                                {pageNumber > 1 && (
                                                    <a
                                                        className="sprite-table-prev-btn"
                                                        onClick={() => {
                                                            this.setState({ pageNumber: pageNumber - 1 }, () => {
                                                                this.getAll();
                                                            });
                                                        }}
                                                    />
                                                )}
                                                <span className="table_page">{pageNumber}</span>
                                                {pageNumber < totalItems / 20 && (
                                                    <a
                                                        className="sprite-table-next-btn"
                                                        onClick={() => {
                                                            this.setState({ pageNumber: pageNumber + 1 }, () => {
                                                                this.getAll();
                                                            });
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </Td>
                                    </Tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                    {is_loaded && error.is && <DataLoadingError message={error.message} />}
                    {is_loaded && data && data.contacts.length == 0 && (
                        <NoResultCas btnOnClick={() => acl.contact.add() && this.props.history.push(`${RoutesPath.contact.add}`)} btnText={acl.contact.add() && disabledData === 0 ? "Créer un contact" : ""} textInfos="Vous n’avez aucun contact pour le moment"></NoResultCas>
                    )}
                </Bloc>
            </div>
        );
    }
    getSearchFromCookies = () => {
        const searchFromCookie = configuration.getSearchFromCookies("Contacts");
        if (searchFromCookie) {
            this.setState((prevState) => ({
                ...prevState,
                ...searchFromCookie.searchOperators,
                ...searchFromCookie.searchValues,
                advancedSearch: searchFromCookie.advancedSearch,
                search: searchFromCookie.search,
            }))
        }
    }
    storeSearchInCookies = () => {
        const { search, advancedSearch } = this.state;
        const { account_id, first_name, last_name, phone, category, selectedOption } = this.state;
        const { account_id_operator, first_name_operator, last_name_operator, phone_operator, category_operator, } = this.state;
        const searchOperators = {
            account_id_operator,
            first_name_operator,
            last_name_operator,
            phone_operator,
            category_operator,
        }
        const searchValues = {
            account_id,
            first_name,
            last_name,
            phone,
            category,
            selectedOption,
        }
        configuration.storeSearchInCookies({ search, advancedSearch, searchOperators, searchValues }, "Contacts");
    }

}

const Th = styled.th`
    cursor: pointer;
    background: ${(props) => props.backgroundColor} !important;
    border-style: solid;
    border-color: #28b9ac;
    border-bottom-width: ${(props) => (props.orderBy === 1 ? "1px" : 0)};
    border-top-width: ${(props) => (props.orderBy === -1 ? "1px" : 0)};
`;
const Td = styled.td`
    border-top: 1px solid #8d8d8d;
    wordwrap: "break-word";
    font-weight: 600;
    padding: 6px 5px;
`;
const Tr = styled.tr`
    cursor: pointer;
`;
const Tag_no = styled.strong`
    padding: 3px 10px 3px 10px;
    border-radius: 3px;
    background-color: #db544c;
    color: #fff;
    display: inline-block;
`;
const Tag_yes = styled.strong`
    padding: 3px 12px 3px 12px;
    border-radius: 3px;
    background-color: #28b9ac;
    color: #fff;
    display: inline-block;
`;
const OrderUp = styled.a`
    background-image: url(${img});
    background-repeat: no-repeat;
    display: inline-block;
    width: 6px;
    height: 4px;
    ${"" /* width: 100px;
    height: 100px; */}
    background-position: -213px -98px;
    position: absolute;
    right: 6px;
    top: 50%;
    margin-top: -4px;
`;
const OrderDown = styled.a`
    background-image: url(${img});
    background-repeat: no-repeat;
    display: inline-block;
    width: 8px;
    height: 5px;
    background-position: -195px -98px;
    position: absolute;
    right: 5px;
    top: 50%;
    margin-top: 4px;
`;
const Search_input_container = styled.div`
    height: 38px;
    position: relative;
`;
const Search_icon = styled.div`
    position: absolute;
    height: 10px;
    width: 10px;
    top: 10px;
    right: 10px;
`;
const Svg = styled.svg`
    width: 15px;
`;
const SearchTr = styled.tr`
    background: "#fff";
`;
const Search_btn = styled.button`
    width: 28px;
    height: 27px;
    outline: none;
    border: 0;
    background: #00beb0;
    position: relative;
    cursor: pointer;
    padding-top: 5px;
    border-radius: 3px;
`;
const Search_btn_icon = styled.svg`
    width: 15px;
`;
const Bloc = styled.div`
    box-shadow: 0 1px 3px 0 #bcbcbc;
    width: 96.3%;
    position: relative;
    margin: auto;
    margin-bottom: 60px;
    margin-top: 10px;
`;
export default ContactsTable;
